import { toast } from "react-toastify";
import fetchRedux from "../../../../api/fetch_redux";
import { ToastErro } from "../../../../utils/utilitarios";

export const USERS_PAGE_INIT = "USERS_PAGE_INIT";
export const USERS_PAGE_SET_MODAL = "USERS_PAGE_SET_MODAL";
export const USERS_PAGE_CLOSE_MODAL = "USERS_PAGE_CLOSE_MODAL";
export const USERS_ADD = "USERS_ADD";
export const USERS_EDIT = "USERS_EDIT";
export const USERS_DELETE = "USERS_DELETE";
export const USERS_X_VARIABLES_INIT = "USERS_X_VARIABLES_INIT";
export const USERS_X_VARIABLES_ADD = "USERS_X_VARIABLES_ADD";
export const USERS_X_VARIABLES_DELETE = "USERS_X_VARIABLES_DELETE";
export const USERS_X_MENU_INIT = "USERS_X_MENU_INIT";
export const USERS_X_MENU_ADD = "USERS_X_MENU_ADD";
export const USERS_X_MENU_DELETE = "USERS_X_MENU_DELETE";
export const MENU_INIT = "MENU_INIT";
export const STORE_INIT = "STORE_INIT";
export const USERS_X_STORE_INIT = "USERS_X_STORE_INIT";
export const USERS_X_STORE_ADD = "USERS_X_STORE_ADD";
export const USERS_X_STORE_DELETE = "USERS_X_STORE_DELETE";

const ROUTE = [
  "/manutencao_usuario_api",
  "/usuario_x_variavel_api",
  "/usuario_x_menu_api",
  "/menu_api",
  "/loja_api",
  "/usuario_x_loja_api",
];

export const usersPageInit = (setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[0],
    "GET",
    null,
    (result) => {
      dispatch({
        type: USERS_PAGE_INIT,
        data: result,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersPageSetModal = (data) => {
  return {
    type: USERS_PAGE_SET_MODAL,
    data,
  };
};

export const usersPageCloseModal = () => {
  return {
    type: USERS_PAGE_CLOSE_MODAL,
  };
};

export const usersPageAddEdit = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[0],
    data?.id ? "PUT" : "POST",
    data,
    (result) => {
      toast.dark(result.sucesso, {
        type: "success",
      });
      // Atualiza a pagina a criacao do usuario
      if (!data?.id) {
        dispatch(usersXStoreInit());
        dispatch(userXMenuInit());
      }
      dispatch({
        type: data?.id ? USERS_EDIT : USERS_ADD,
        data: result.data,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersPageUpdPassword = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[0],
    "PATCH",
    data,
    (result) => {
      toast.dark(result.sucesso, {
        type: "success",
      });
      dispatch(usersPageCloseModal());
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersPageDelete = (id, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[0],
    "DELETE",
    { id: id },
    (result) => {
      toast.dark(result.sucesso, {
        type: "success",
      });
      dispatch({
        type: USERS_DELETE,
        data: id,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersXVariablesInit = (setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[1],
    "GET",
    null,
    (result) => {
      dispatch({
        type: USERS_X_VARIABLES_INIT,
        data: result,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersXVariablesAdd = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[1],
    "POST",
    data,
    (result) => {
      dispatch({
        type: USERS_X_VARIABLES_ADD,
        data: result.data,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersXVariablesDelete = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[1],
    "DELETE",
    data,
    (result) => {
      dispatch({
        type: USERS_X_VARIABLES_DELETE,
        data: result.data,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const userXMenuInit = (setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[2],
    "GET",
    null,
    (result) => {
      dispatch({
        type: USERS_X_MENU_INIT,
        data: result,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const userXMenuAdd = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[2],
    "POST",
    data,
    (result) => {
      dispatch({
        type: USERS_X_MENU_ADD,
        data: result.data,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const userXMenuDelete = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[2],
    "DELETE",
    data,
    (result) => {
      dispatch({
        type: USERS_X_MENU_DELETE,
        data: result.data,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersPageMenuInit = (setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[3],
    "GET",
    null,
    (result) => {
      dispatch({
        type: MENU_INIT,
        data: result,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersPageStoreInit = (setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[4],
    "GET",
    null,
    (result) => {
      dispatch({
        type: STORE_INIT,
        data: result,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersXStoreInit = (setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[5],
    "GET",
    null,
    (result) => {
      dispatch({
        type: USERS_X_STORE_INIT,
        data: result,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersXStoreAdd = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[5],
    "POST",
    data,
    (result) => {
      dispatch({
        type: USERS_X_STORE_ADD,
        data: result.data,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersXStoreDelete = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[5],
    "DELETE",
    data,
    (result) => {
      dispatch({
        type: USERS_X_STORE_DELETE,
        data: result.data,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};
